import { Tabs, TabsProps, Form } from "antd";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useReactiveVar } from "@apollo/client";

import "./storyTimeDetail.scss";
import type { StoryTimeDetailType } from "./content/storyTimeType"
import StoryTimeDetailLearning from "./storyTimeDetailLearning";
import StoryTimeDetailScript from "./storyTimeDetailScript";
import { header } from "../utils/zippyAdminHeader";
import MainContentHeader from "../../../components/layout/mainContent/MainContentHeader";
import Spinner from "../../../components/layout/spinner/Spinner";
import { __currentUser__ } from "../../../graphql/policies";
import { ServiceTypes } from "../../../types/types";
import { apiCall } from "../../../utils/apiCall";

interface StoryTimeDetailProps {
  setSelectedService: Dispatch<SetStateAction<ServiceTypes>>;
  setSelectSubItem: Dispatch<SetStateAction<string | undefined>>;
}

const StoryTimeDetail = ({
  setSelectedService,
  setSelectSubItem,
}: StoryTimeDetailProps) => {
  const currentUser = useReactiveVar(__currentUser__);
  const userName = currentUser?.userName;

  const { id }: any = useParams();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [detailInfo, setDetailInfo] = useState<StoryTimeDetailType>();

  const [ScriptForm] = Form.useForm();
  const [LearningForm] = Form.useForm();

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "Upload Media & Create Script",
      children: (
        <StoryTimeDetailScript
          storyGroupId={id}
          detailInfo={detailInfo}
          scriptForm={ScriptForm}
          userName={userName}
        />
      ),
    },
    {
      key: "2",
      label: "Add Learning Content",
      children: (
        <StoryTimeDetailLearning
          storyGroupId={id}
          detailInfo={detailInfo}
          learningForm={LearningForm}
          userName={userName}
        />
      ),
    }
  ];

  useEffect(() => {
    setSelectedService(ServiceTypes.ZIPPY_AND_ME);
    setSelectSubItem("Story Time");
    fetchStoryTimeGroup();
  }, []);

  const fetchStoryTimeGroup = async () => {
    setIsLoading(true);

    const data = await apiCall({
      method: "GET",
      header: header,
      endPoint:
        process.env.REACT_APP_ZIPPY_ADMIN +
        "/stories/admin/groups/" +
        id
    });
    
    if (data) {
      setDetailInfo(data);
    }

    setIsLoading(false);
  }

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <div id="storyDetailWrapper">
      <div style={{ position: "relative", paddingBottom: 48 }}>
        <MainContentHeader
          title="Story detail"
        />
        <Tabs
          defaultActiveKey="1"
          items={items}
          size="small"
          tabBarStyle={{
            paddingLeft: 24,
            height: 50,
          }}
        />
      </div>
    </div>
  );
};

export default StoryTimeDetail;
